// extracted by mini-css-extract-plugin
module.exports = {"dropdown_item":"DropdownItem_dropdown_item__1LUab"};